import Model from "../Model";

class ComercialsByGestnogest extends Model{

    buildUrl ({ param }) {
        return ['companyview/getgroupbyindustrialgroup', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new ComercialsByGestnogest;